import React from 'react';
import { Paperclip, AlertCircle, Check } from 'lucide-react';

export function Suggestion({ children, onClick }) {
  return (
    <button onClick={onClick} className="w-full text-left px-3 py-2 bg-white border border-slate-200 rounded text-xs hover:border-primary hover:bg-primary transition-colors">
      {children}
    </button>
  );
}

function ActionResultData({ data }) {
  return (
    <>
      {data.clienti && data.clienti.length > 0 && (
        <ul className="mt-1 space-y-0.5">
          {data.clienti.map((c, i) => <li key={c.email || c.label || i} className="text-[11px]">· {c.label} ({c.email || 'no email'})</li>)}
        </ul>
      )}
      {data.fatture && data.fatture.length > 0 && (
        <ul className="mt-1 space-y-0.5">
          {data.fatture.slice(0, 5).map((f, i) => <li key={f.numero || i} className="text-[11px]">· {f.numero} {f.cliente} · {f.residuo?.toFixed(2)}EUR · {f.giorni}gg</li>)}
        </ul>
      )}
    </>
  );
}

export function MessageBubble({ m, nome }) {
  if (m.role === 'user') {
    return (
      <div className="flex justify-end">
        <div className="max-w-[85%] bg-primary text-white rounded-md rounded-br-sm px-3 py-2 text-sm">
          {m.upload_name && (
            <div className="flex items-center gap-1 text-[10px] bg-white/20 rounded px-1.5 py-0.5 mb-1">
              <Paperclip size={10} /> {m.upload_name}
            </div>
          )}
          {m.content || <em className="opacity-70">(allegato)</em>}
        </div>
      </div>
    );
  }
  if (m.role === 'error') {
    return (
      <div className="flex items-start gap-1.5 text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2 text-xs">
        <AlertCircle size={14} className="flex-shrink-0 mt-0.5" /> {m.content}
      </div>
    );
  }
  if (m.role === 'action_result') {
    return (
      <div className="flex items-start gap-1.5 text-green-800 bg-green-50 border border-green-200 rounded-md px-3 py-2 text-xs">
        <Check size={14} className="flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold">{m.content}</p>
          {m.data && <ActionResultData data={m.data} />}
        </div>
      </div>
    );
  }
  return (
    <div className="flex justify-start">
      <div className="max-w-[85%] bg-white border border-slate-200 rounded-md rounded-bl-sm px-3 py-2 text-sm">
        <p className="text-[10px] font-bold text-primary mb-0.5">{nome}</p>
        <p className="text-slate-800 whitespace-pre-wrap">{m.content}</p>
      </div>
    </div>
  );
}
